module.exports = __webpack_public_path__ + "img/thumb-020.1e2c58a5.png";